import { ThemeOptions, PaletteColor, PaletteColorOptions } from '@mui/material/styles';
import { green, blue } from '@mui/material/colors';

declare module '@mui/material/styles' {
    interface Palette {
        icon: PaletteColor;
        button: PaletteColor;
    }
    interface PaletteOptions {
        icon?: PaletteColorOptions;
        button?: PaletteColorOptions;
    }
}

declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        icon: true;
        button: true;
    }
}

declare module '@mui/material/IconButton' {
    interface IconButtonPropsColorOverrides {
        icon: true;
        button: true;
    }
}

declare module '@mui/material/SvgIcon' {
    interface SvgIconPropsColorOverrides {
        icon: true;
        button: true;
    }
}

// Base options only -- the actual theme is constructed in App.tsx via
// createTheme(themeOptions, muiLocale) so MUI's own core-component strings
// (e.g. TablePagination's "Rows per page") react to the active language too.
export const themeOptions: ThemeOptions = {
    palette: {
        primary: {
            // light/dark are intentionally omitted -- MUI derives them from
            // `main` (green[700]) automatically. They used to be hardcoded
            // to unrelated blue hex values, left over from a copy-pasted
            // example, which fought the green brand everywhere primary.light
            // or primary.dark was used (e.g. Home's hero background).
            main: green[700],
            contrastText: '#fff',
        },
        secondary: {
            main: blue[500],
            light: green[50],
        },
        icon: {
            main: green[50],
            dark: green[800],
        },
        button: {
            main: green[50],
            dark: green[300],
            light: green[50],
            contrastText: green[700],
        },
    },
    typography: {
        fontFamily: 'Arial, sans-serif',
    },
};
